// v5
if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * ((Shopify.currency && Shopify.currency.rate) || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (total < minimum) {
        percentage = total / minimum;
        if (amount_text) {
          let remaining = minimum - total;
          let format = (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) || '${{amount}}';
          try {
            amount_text.innerHTML = Shopify.formatMoney(remaining, format);
          } catch(e) {
            amount_text.innerHTML = '$' + (remaining / 100).toFixed(2);
          }
        }
        if (this.remainingText) this.remainingText.style.display = 'block';
        if (this.fullText) this.fullText.style.display = 'none';
      } else {
        if (this.remainingText) this.remainingText.style.display = 'none';
        if (this.fullText) this.fullText.style.display = 'block';
      }
      this.style.setProperty('--percentage', percentage);
      let bar = this.querySelector('.free-shipping--percentage');
      if (bar) bar.style.transform = 'scale(' + percentage + ', 1)';
    }
  }
  customElements.define('free-shipping', FreeShipping);
}